import { IconWrapper } from '../runtime';
export default IconWrapper('archive_format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V3Z",
      "fill": "#E8B600"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 18.375H24V21C24 22.6569 22.6569 24 21 24H3C1.34315 24 0 22.6569 0 21V18.375Z",
      "fill": "#DBAC00"
    }
  }), h("path", {
    "attrs": {
      "d": "M21 1.14742e-07C22.6569 1.87166e-07 24 1.34315 24 3L24 21.0968C24 22.7002 22.7002 24 21.0968 24C19.5936 24 18.375 22.7814 18.375 21.2782L18.375 0L21 1.14742e-07Z",
      "fill": "#F7C200"
    }
  }), h("path", {
    "attrs": {
      "d": "M18.375 21.2782C18.375 22.7814 19.5936 24 21.0968 24C22.7002 24 24 22.7002 24 21.0968C24 19.5936 22.7814 18.375 21.2782 18.375H18.375V21.2782Z",
      "fill": "#E8B600"
    }
  }), h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M9.1875 1.125H6.1875V2.25H9.1875V3.28125H6.1875V4.40625H9.1875V5.53125H6.1875V6.65625H9.1875V7.78125H6.1875V8.90625H9.1875V10.0312H6.1875V11.1562V14.4375H12.1875V11.1562H9.1875V10.0312H12.1875V8.90625H9.1875V7.78125H12.1875V6.65625H9.1875V5.53125H12.1875V4.40625H9.1875V3.375H12.1875V2.25H9.1875V1.125ZM7.3125 13.3125V12.1875H11.0625V13.3125H7.3125Z",
      "fill": "white"
    }
  })]);
});